import { useSelector } from "react-redux";

import { showType } from "../../../../utils/textUtils";

// 일반 내용이해 문제 머리(2026-10-25 대표: "내용이해 원서형 아니더라도 예쁘게"). 원서 워크북 머리(BookWorkbookPage 의
// activityHead)처럼: 검정 Q칩 + 영어 활동 이름 → 굵은 제목 → 안내 → 얇은 진행 줄. 꾸밈은 ComprehensiveBook.css.
const ACTIVITY_LABEL = {
  ox: "True or False",
  ox_kor: "True or False",
  ox_kor_high: "True or False",
  ox_eng: "True or False",
  ox_eng_high: "True or False",
  translation: "Translation",
  scramble: "Sentence Building",
  paraphrasing_scramble: "Sentence Building",
  summary: "Summary",
  summary_blank: "Summary",
  summary_blank_low: "Summary",
  understanding: "Comprehension",
  understanding_test: "Comprehension",
  keyword: "Key Words",
  keyword_meaning: "Key Words",
  num_repeats: "Key Words",
};

const ComprehensiveBookHead = ({ index, total, instruction }) => {
  const section = useSelector((state) => state.assignment.section);
  const sectionType = section?.type || "";
  const title = section?.type_name || showType("comprehensive", sectionType);
  return (
    <div className="comp-book__head">
      <div className="comp-book__head-row">
        <span className="comp-book__chip">Q{index + 1}</span>
        <span className="comp-book__label">{ACTIVITY_LABEL[sectionType] || "Comprehension"}</span>
        <span className="comp-book__count">
          {index + 1} / {total}
        </span>
      </div>
      <div className="comp-book__title">{title}</div>
      {instruction && <div className="comp-book__instruction">{instruction}</div>}
      <div className="comp-book__progress">
        <i style={{ width: `${((index + 1) / Math.max(total, 1)) * 100}%` }} />
      </div>
    </div>
  );
};

export default ComprehensiveBookHead;
